import {
  Component,
  EventEmitter,
  Output,
  Input,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewChildren,
  QueryList
} from "@angular/core";

@Component({
    selector: "hub-chip",
    templateUrl: "./hub-chip.component.html",
})
export class HubChipComponent {
    @Input() public chips: any;

    @Output()
    public emmiter: EventEmitter<any> = new EventEmitter();

    @ViewChildren("chip")
    public chipsElements: QueryList<any>;
    @ViewChild("chip", { static: true })
    public chipElement: ElementRef;

    constructor(private renderer: Renderer2) {}

    public chipSelect(id, value) {
        const chips = this.chipsElements.toArray() as ElementRef[];
        const chip = chips[id].nativeElement;
        const listChips = Array.from(document.querySelectorAll(".chips--item"));
        listChips.forEach((element) => {
            if (element.classList.contains("mat-chip--selected")) {
                element.classList.remove("mat-chip--selected");
                element.setAttribute("selected", "false");
            }
        });

        this.emmiter.emit({
            type: "filter",
            value: { id, value },
            first: false,
        });
        chip.classList.add("mat-chip--selected");
        return false;
    }
}
